"use client";

import { useFormContext } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { cn } from '@/lib/utils';

interface InputFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  maxLength?: number;
  disabled?: boolean;
  className?: string;
  onValueChange?: (value: string) => void;
}

export function InputField({ 
  name, 
  label, 
  placeholder, 
  type = "text", 
  required = false,
  maxLength,
  disabled = false,
  className,
  onValueChange,
}: InputFieldProps) {
  const form = useFormContext();
  
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col">
          <FormLabel>{label} {required && '*'}</FormLabel>
          <FormControl>
            <Input
              type={type}
              maxLength={maxLength}
              placeholder={placeholder}
              readOnly={disabled}
              className={cn(
                disabled && "bg-muted opacity-50 cursor-text select-text",
                className
              )}
              {...field}
              onChange={(event) => {
                if (disabled) return;
                field.onChange(event);
                onValueChange?.(event.target.value);
              }}
              value={field.value ?? ''}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
